/**
 * @author shijianan
 * @param  {function} getData - 获取数据的回调函数
 * @param  {object} options={} - 配置项
 */
module.exports = function scrollLoad(getData) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var target = options.target,
      _options$root = options.root,
      root = _options$root === undefined ? document.body : _options$root,
      _options$distance = options.distance,
      distance = _options$distance === undefined ? '100px' : _options$distance,
      _options$direction = options.direction,
      direction = _options$direction === undefined ? 'down' : _options$direction;


  var rootMargin = '0px 0px ' + distance + ' 0px';
  if (direction !== 'down') {
    rootMargin = distance + ' 0px 0px 0px';
  }
  try {
    var io = new window.IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting || entries[0].intersectionRatio) {
        getData();
      }
    }, {
      threshold: [0.000001],
      rootMargin: rootMargin,
      root: root
    });

    if (!target) {
      target = document.createElement('div');
      if (direction === 'up') {
        // 在root之前插入节点
        root.insertBefore(target);
      } else if (direction === 'down') {
        // 在root里面插入节点
        root.appendChild(target);
      }
    }
    // 开始观察
    io.observe(target);
  } catch (error) {
    console.info('Your browser does not support IntersectionObserver,\n    please upgrade your browser or use polyfill:\n    https://github.com/WICG/IntersectionObserver/tree/gh-pages/polyfill');
  }
};
